export const HIDE_HEADER = 'UI/HIDE_HEADER';

export const SHOW_MODAL = 'UI/SHOW_MODAL';
export const HIDE_MODAL = 'UI/HIDE_MODAL';

export const SET_LOADER_STATE = 'UI/SET_LOADER_STATE';

export const HIDE_PROGRESS_BAR = 'UI/HIDE_PROGRESS_BAR';
